import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';

export const SectionWrapper = styled.section`
  width: 100%;
`;

export const Title = styled.h2`
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(22)};
  font-weight: 600;
  line-height: ${props => props.theme.rem(26)};
  color: ${props => props.theme.reviews.text};
  margin-bottom: ${props => props.theme.space(4)};
`;

export const Block = styled.article`
  background: ${props => props.theme.backgrounds.lightest};
  border-radius: 12px;

  > div {
    p {
      margin-top: ${props => props.theme.space(4)};
    }
  }
`;

export const ReviewsHeader = styled.div`
  display: flex;
  padding-bottom: ${props => props.theme.space(5)};

  .expand__button {
    align-self: flex-end;
    margin-left: auto;
    margin-right: ${props => props.theme.space(20)};

    ${mediaMin.extraSmallBreakpoint`
      display: none;
    `}
  }

  ${mediaMin.smallBreakpoint`
    flex-direction: column;
  `}
`;

export const ReviewsHeaderElement = styled.div`
  display: flex;
  flex-direction: column;

  &:first-of-type {
    margin-right: 100px;

    ${mediaMin.smallBreakpoint`
      order: 1;
      margin-top: ${props => props.theme.space(5)};
    `}
  }

  h3 {
    font-family: IntervalNextReg, sans-serif;
    font-size: ${props => props.theme.rem(18)};
    font-weight: 600;
    line-height: ${props => props.theme.rem(20)};
    color: ${props => props.theme.reviews.text};
    margin-bottom: ${props => props.theme.space(3)};

    span {
      font-family: IntervalNextReg, sans-serif;
      font-size: ${props => props.theme.rem(14)};
      font-weight: 400;
      line-height: ${props => props.theme.rem(18)};
      color: ${props => props.theme.reviews.text};
    }
  }
`;
